/**
 * The goal here is to update tax switched prices with the calculated pewc total.
 *
 * which involves:
 * - knowing if the display prices contain tax
 *   (important in terms of, this is what the pewc calculated price will also be)
 * - Knowing the tax rate of the product in order to set the excl & incl tax prices appropriately
 *
 * This information should all be passed through to the frontend via teh NuWoo object.
 * e.g
 * NuWoo.settings.shop_display_with_tax - Is whether prices on the front end include tax (by default)
 * NuWoo.settings.prices_include_tax - Is whether input prices contain tax (Only required for custom plugin logic)
 * NuWoo.product.tax_rate - Calculated from the products incl & excl price (Not applicable to individual variations however!)
 */

import { get } from "@/utilities/querySelector";

jQuery( function( $ ) {
    const form = /** @type {HTMLFormElement} */ ( get( '.nuwoo-product .summary form.cart' ) );
    if ( !form ) return;

    const is_pewced = !!form.querySelector( '.pewc-product-extra-groups-wrap' );
    if ( !is_pewced ) return;


    if ( is_variable() ) {
        $( document.body ).on( 'pewc_after_update_total_js', update_variation_prices );
    } else if ( is_modifiable() ) {
        $( document.body ).on( 'pewc_after_update_total_js', update_prices );
    }

    // Force recalculation of pewc totals on load, so that default options have the price applied
    window.addEventListener( 'load', () => {
        $( 'body' ).trigger( 'pewc_force_update_total_js' );
    }, { once: true } );

    function is_variable() {
        return !!get( 'table.variations', form );
    }

    function is_modifiable() {
        return !!get( '.nuwoo-modified-totals' );
    }

    function is_variation_chosen() {
        return !!get( '.woocommerce-variation-price', form );
    }

    function update_variation_prices( _event, _options_price, total_price, _total_price_html ) {
        if ( !is_variation_chosen() ) return;

        update_prices( _event, _options_price, total_price, _total_price_html );
    }

    function update_prices( _event, _options_price, total_price, _total_price_html ) {
        const tax_rate = get_tax_price_ratio();
        let incl_price;
        let excl_price;

        if ( NuWoo.settings.shop_display_with_tax ) {
            incl_price = total_price;
            excl_price = total_price / tax_rate;
        } else {
            excl_price = total_price;
            incl_price = total_price * tax_rate;
        }

        get_price_incl_tax_element().innerHTML = pewc_wc_price( incl_price );
        get_price_excl_tax_element().innerHTML = pewc_wc_price( excl_price );
    }

    function get_price_incl_tax_element() {
        return get( '[data-price-incl-tax]', form );
    }

    function get_price_excl_tax_element() {
        return get( '[data-price-excl-tax]', form );
    }

    /**
     * inc price / exc_price
     *
     * @return {number}
     */
    function get_tax_price_ratio() {
        const incl_price = parseFloat( get_price_incl_tax_element()?.getAttribute( 'data-price-incl-tax' ) ?? '0' );
        const excl_price = parseFloat( get_price_excl_tax_element()?.getAttribute( 'data-price-excl-tax' ) ?? '0' );
        return incl_price / excl_price;
    }
} );